import inventoryService from '../../../services/inventoryService';
import { usePaginationState } from '../../../hooks/usePaginationState.js';
import { usePaginatedData } from '../../../hooks/usePaginatedData.js';

export const useMovements = (options = {}) => {
    const paginationState = usePaginationState({
        defaultSort: 'created_at',
        defaultOrder: 'desc',
        defaultLimit: options.defaultLimit || 10,
        limitOptions: options.limitOptions || [10, 20, 50, 100]
    });

    const { data, pagination, loading, error, setError, refetch } = usePaginatedData(
        inventoryService.getAllMovements,
        paginationState
    );

    const loadMovements = async (params = {}) => {
        await refetch(params);
    };

    return {
        data,
        movements: data,
        pagination,
        loading,
        error,
        setError,
        loadMovements,
        refetch,
        ...paginationState
    };
};